import React from 'react';
import TextCounter from '../components/TextCounter';
import SeoText from '../components/SeoText';

function Custom({ markAIUsed }) {
  return (
    <>
      {/* Tools Section */}
      <div className="max-w-6xl mx-auto px-6 pb-12">
        <TextCounter markAIUsed={markAIUsed} />
      </div>

      {/* Documentation Section - White Background */}
      <div className="bg-white">
        <SeoText />
      </div>
    </>
  );
}

export default Custom; 